import { Doughnut } from 'react-chartjs-2';
import { Box, Card, CardContent, CardHeader, Typography, useTheme } from '@mui/material';
import LaptopMacIcon from '@mui/icons-material/LaptopMac';
import TabletIcon from '@mui/icons-material/Tablet';

export const MuayeneTetkikCiroOranGrafik = (props) => {
  const theme = useTheme();

  const totalMonthlyIncoming = (props.data.length === 4) ? props.data[0] + props.data[1] + props.data[2] + props.data[3] : 0

  const data = {
    datasets: [
      {
        data: (props.data.length > 0) ? [(props.data[0] === 0) ? 0 : props.data[0], (props.data[1] === 0) ? 0 :props.data[1], (props.data[2] === 0) ? 0 :  props.data[2]] : [0, 0, 0],
        backgroundColor: ['#3F51B5', '#e53935', '#52BE80', '#3498DB'],
        borderWidth: 8,
        borderColor: '#FFFFFF',
        hoverBorderColor: '#FFFFFF'
      }
    ],
    labels: ['Muayene', 'Tetkik', "Hizmet"]
  };

  const options = {
    animation: false,
    cutoutPercentage: 80,
    layout: { padding: 0 },
    legend: {
      display: false
    },
    maintainAspectRatio: false,
    responsive: true,
    tooltips: {
      backgroundColor: theme.palette.background.paper,
      bodyFontColor: theme.palette.text.secondary,
      borderColor: theme.palette.divider,
      borderWidth: 1,
      enabled: true,
      footerFontColor: theme.palette.text.secondary,
      intersect: false,
      mode: 'index',
      titleFontColor: theme.palette.text.primary
    }
  };

  const ciroData = [
    {
      title: 'Muayene',
      value: (props.data.length === 4) ? isNaN(((props.data[0] / totalMonthlyIncoming) * 100).toFixed()) ? 0 :  ((props.data[0] / totalMonthlyIncoming) * 100).toFixed() : 0 ,
      icon: LaptopMacIcon,
      color: '#3F51B5'
    },
    {
      title: 'Hizmet',
      value: (props.data.length === 4) ? isNaN(((props.data[2] / totalMonthlyIncoming) * 100).toFixed()) ? 0 : ((props.data[2] / totalMonthlyIncoming) * 100).toFixed() : 0 ,
      icon: TabletIcon,
      color: '#52BE80'
    },
    {
      title: 'Tetkik',
      value: (props.data.length === 4) ? isNaN(((props.data[3] / totalMonthlyIncoming) * 100).toFixed()) ? 0: ((props.data[3] / totalMonthlyIncoming) * 100).toFixed() : 0,
      icon: TabletIcon,
      color: '#e53935'
    }
  ];

  return (
    <Card {...props} >
      <CardHeader title="Ciro Dağılımı" />
      <CardContent>
        <Box
          sx={{
            height: 300,
            position: 'relative'
          }}
        >
          <Doughnut
            data={data}
            options={options}
          />
        </Box>
        <Box
          sx={{
            display: 'flex',
            justifyContent: 'center',
            pt: 2
          }}
        >
          {ciroData.map(({
            color,
            icon: Icon,
            title,
            value
          }) => (
            <Box
              key={title}
              sx={{
                p: 1,
                textAlign: 'center'
              }}
            >
              <Typography
                color="textPrimary"
                variant="body1"
              >
                {title}
              </Typography>
              <Typography
                style={{ color }}
                variant="h4"
              >
                {value}
                %
              </Typography>
            </Box>
          ))}
        </Box>
      </CardContent>
    </Card>
  );
};
